import React from 'react';

const TransactionIdDarkIcon = () => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="43" viewBox="0 0 42 43" fill="none">
      <rect opacity="0.3" y="0.5" width="42" height="42" rx="10" fill="white" fillOpacity="0.4"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M31 23.4527V15.5455L23.0928 15.5455L23.0928 17.3905L27.8371 17.3905L21.7749 23.4527L23.0928 24.7706L29.155 18.7084V23.4527H31ZM11 20.5479V28.4551H18.9072V26.6101H14.1629L20.2251 20.5479L18.9072 19.23L12.845 25.2922V20.5479H11Z" fill="url(#paint0_linear_700_2647)"/>
      <defs>
        <linearGradient id="paint0_linear_700_2647" x1="21" y1="15.5454" x2="21" y2="28.4551" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EF5F14"/>
          <stop offset="1" stopColor="#E88947"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TransactionIdDarkIcon;
